import { render, staticRenderFns } from "./create-or-edit-wechat-app-config.vue?vue&type=template&id=241f169b&scoped=true&"
import script from "./create-or-edit-wechat-app-config.vue?vue&type=script&lang=js&"
export * from "./create-or-edit-wechat-app-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f169b",
  null
  
)

export default component.exports